import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "logo-container mt-6" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-center justify-center" }

import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/useUser';
import { rules, valid, show } from '@/store/stateless/rules';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'loginPartial',
  setup(__props) {

const user = useUserStore();
const { email, password, errorMessage, isError, loading } = storeToRefs(user);
const { signin } = useUserStore();
const doSignin = async () => {
  try {
    await signin();
    await router.push({ name: 'Home' });
  } catch (error) {
    console.error('Login or navigation failed:', error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_row, {
    justify: "center",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: require('@/assets/logo-no-padding.png'),
              style: {"width":"40%"},
              alt: "Logo of company"
            }, null, 8, _hoisted_2),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Connectez-vous au compte existant sur Taxelco", -1))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            modelValue: _unref(valid).login,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(valid).login) = $event)),
            ref: "form",
            "lazy-validation": "",
            onSubmit: _withModifiers(doSignin, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            label: "Courriel",
                            modelValue: _unref(email),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                            "prepend-inner-icon": "mdi-email",
                            rules: _unref(rules).login.email,
                            variant: "solo",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(password),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                            "append-icon": _unref(show).password ? 'mdi-eye' : 'mdi-eye-off',
                            rules: _unref(rules).login.password,
                            type: _unref(show).password ? 'text' : 'password',
                            name: "password",
                            label: "Mot de passe",
                            hint: "Au moins 8 caractères",
                            variant: "solo",
                            "onClick:append": _cache[2] || (_cache[2] = ($event: any) => (_unref(show).password = !_unref(show).password))
                          }, null, 8, ["modelValue", "append-icon", "rules", "type"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          (_unref(isError))
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "error"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(errorMessage)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_btn, {
                              variant: "outlined",
                              type: "submit",
                              color: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(!_unref(loading) ? 'Connexion' : 'Chargement...'), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})